import {
  PaymentStatusActionTypes,
  PAYMENT_STATUS_FAIL,
  PAYMENT_STATUS_LOADING,
  PAYMENT_STATUS_SUCCESS,
  PaymentStatusState,
  PAYMENT_STATUS_UPDATE_API_MSG,
  PAYMENT_STATUS_UPDATE_API_RES,
} from "./ActionTypes";
import { PaymentStatusResponse } from "./Model";

const initialStateGetPosts: PaymentStatusState = {
  loading: false,
  statusPaymentRes: {} as PaymentStatusResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const statusPaymentReducer = (
  state = initialStateGetPosts,
  action: PaymentStatusActionTypes
): PaymentStatusState => {
  switch (action.type) {
    case PAYMENT_STATUS_LOADING:
      return {
        ...state,
        loading: true,
        statusPaymentRes: {} as PaymentStatusResponse,
      };
    case PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusPaymentRes: action.payload,
        successMsg: action.successMsg,
        status: action.status
      };
    case PAYMENT_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        statusPaymentRes: {} as PaymentStatusResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PAYMENT_STATUS_UPDATE_API_MSG:
      return {
        ...state,
        loading: false,
        statusPaymentRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PAYMENT_STATUS_UPDATE_API_RES:
      return {
        ...state,
        loading: false,
        statusPaymentRes: {} as PaymentStatusResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
